import React,{ useState, useEffect } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { MatchParams, SubscriptionsInputs, Var } from '../types'
import { Helmet } from "react-helmet";
import { expiryFormat, smsAgreeShow, linkify } from '../../lib/utils';
import { useForm } from 'react-hook-form'
import useSubscriptions from '../../hooks/useSubscriptions';
import useSubscribeList from '../../hooks/useSubscribeList';
import { registerListDTO } from '../../lib/api/types'
import useLists from '../../hooks/useLists';
import { numberWithCommas } from '../../lib/utils'
import CreditCardPaymentFields from '../../components/Payment/CreditCardPaymentFields';
import ReCAPTCHA from 'react-google-recaptcha'
import { josa } from 'josa'
import querystring from 'query-string'

type subscriptionQS = {
  groupIds?:string
}
declare global {
  interface Window {
    Naver: any;
    IMP: any;
    amplitude: any;
  }
}

export type callEasyPaymentsBodyTypes = {
  paymentType: string
  customerUid?: string
  merchantUid?: string
  buyerEmail?: string
  buyerName?: string
  buyerTel?: string
}

// window.Naver = window.Naver || {};

function SubscriptionsPage (props:RouteComponentProps<MatchParams>) {

  const listId = props.match.params.listId
  const uA = navigator.userAgent
  const { IMP, amplitude } = window
  const { history } = props 

  const { getListsInfoData, listsInfo } = useLists()
  const { subscribe, subscribeStatus } = useSubscribeList()
  const { getSubscriptionsInfoData, subscriptionsInfo } = useSubscriptions()
  const { formSettings, varsSettings } = subscriptionsInfo.data

  const [ email, setEmail ] = useState('')
  const [ result, setResult ] = useState('')
  const [ resultMsg, setResultMsg ] = useState<string>('')
  const [ captchaValue, setCaptchaValue ] = useState('')

  const [ isIosInstagram, setIsIosInstagram ] = useState(false)
  
  //react-hook-form
  const { register, handleSubmit, errors, setError, setValue, clearErrors } = useForm<SubscriptionsInputs>()

  
  
  useEffect(()=>{
    getListsInfoData(listId)
    getSubscriptionsInfoData(listId)
    amplitude.getInstance().logEvent("pageview", {"listId": listId});
  },[])

  useEffect(()=>{
    if(uA.includes("Instagram") && uA.includes("iOS") && formSettings.formIsActive === 'Y' && formSettings.formPaidSubscription === 'Y'){
      setIsIosInstagram(true)
    }
  },[formSettings])

  useEffect(()=>{
    //삭제된 주소록인 경우
    if(subscriptionsInfo.error && subscriptionsInfo.errorData?.response?.data.Code === 'Errors.List.NotExistList'){
      window.location.href = `/subscriptions/${listId}/error`;
    }
    if(listsInfo.error && listsInfo.errorData?.response?.data.Code === 'Errors.List.NotExistList'){
      window.location.href = `/subscriptions/${listId}/error`;
    }
  },[subscriptionsInfo, listsInfo])

  useEffect(()=>{
    /* 비동기 처리 성공 */
    if(subscribeStatus.status === 'success'){
      
      captcha?.reset();
      setCaptchaValue('')
      if(subscribeStatus.data.code === 'Succeed.List.NonConfirm.NonPaid' || subscribeStatus.data.code === 'Succeed.List.NonConfirm.Paid'){
        setResult('success')
        setResultMsg(subscribeStatus.data.message)
        console.log(formSettings)
        history.push({
          pathname:`/subscriptions/${listId}/result`,
          // search: `?email=${email}`,
          state: { status: 'NonConfirm', listName:listsInfo.data.listName, modifyUrl: `/subscribers/auth/${listId}?email=${email}`, resultMsg:subscribeStatus.data.message }
        })
      } else if (subscribeStatus.data.code === 'Succeed.List.Confirm.NonPaid' || subscribeStatus.data.code === 'Succeed.List.Confirm.Paid'){
        setResult('success')
        setResultMsg(subscribeStatus.data.message)
        history.push({
          pathname:`/subscriptions/${listId}/result`,
          // search: `?email=${email}`,
          state: { status: 'Confirm', listName:listsInfo.data.listName, resultMsg:subscribeStatus.data.message }
        })
      } else if (subscribeStatus.data.code === 'Succeed.Payment.CustomerUid' && paymentOption === 'KAKAOPAY'){
        const { customerUid, merchantUid, buyerEmail, buyerName, buyerTel } = subscribeStatus.data
        const easyPaymentsBody:callEasyPaymentsBodyTypes = {
          paymentType:paymentOption,
          buyerEmail:buyerEmail,
          buyerName:buyerName,
          buyerTel:buyerTel,
          customerUid:customerUid,
          merchantUid:merchantUid
        }
        callEasyPayments(easyPaymentsBody,process.env.REACT_APP_API_URI)
      }

    /* 비동기 처리 실패 */
    }else if(subscribeStatus.status ==='failure'){
      captcha?.reset();
      setCaptchaValue('')
      // clearErrors();
      
      switch(subscribeStatus.errorData?.response?.data.Code){
        case 'Errors.List.AlreadyExistEmail':
          setError('email',{type:'duplicated'});
          setResult('fail')
          setResultMsg('이런, 뭔가 잘못된 것 같습니다. 입력한 값을 다시 확인하세요.'); 
          break;
        // case 'Errors.List.NoSubscriberName':
        //   setError('name',{type:'required'});
        //   break;
        case 'Errors.Payment.InvalidPaymentInformation':
          setResult('fail')
          setResultMsg('잘못된 결제 정보입니다.');
          break;
        case 'Errors.Payment.FailedToPay':
          // setResult('fail')
          // setResultMsg('결제에 실패했습니다.');
          history.push({
            pathname:`/subscriptions/${listId}/result`,
            // search: `?email=${email}`,
            state: { status: 'FailedToPay', listName:listsInfo.data.listName, resultMsg:'결제에 실패하여 구독 신청이 완료되지 않았습니다.\r\n결제 정보를 다시 입력하여 결제를 다시 시도하세요.', subscriptionUrl: `/subscriptions/${listId}`}
          })

          break;
        default:
          clearErrors();
          setResult('fail')
          setResultMsg(subscribeStatus.errorData?.response?.data.Message||'알수없는 오류')
        }
      }
    
  },[subscribeStatus])

  useEffect(()=>{
    if(Object.keys(errors).length > 0){
      setResult('fail')
      setResultMsg('이런, 뭔가 잘못된 것 같습니다. 입력한 값을 다시 확인하세요.'); 
    }
  },[errors])

  //submit button event
  const onClickSubmit =()=>{
      clearErrors();
      setResult('')
      setResultMsg('')
  }
  
  async function onSubmit (data:SubscriptionsInputs) {
    amplitude.getInstance().logEvent("subscribe", {"listId": listId});
    //구독정보 변경 url용
    setEmail(data.email)
    const qs:subscriptionQS = querystring.parse(window.location.search)

    let list:registerListDTO = {
      email: data.email,
      name: data.name,
      phone_number: data.phone_number,
    }
    
    let subscriber:any = Object.assign({},data)
    delete subscriber['email']; 
    delete subscriber['name'];
    delete subscriber['phone_number']

    list = Object.assign(list, {subscriber: subscriber})

    if(selectPaidSubscription === 'Y'){
      if(paymentOption === 'CREDITCARD'){
        list = Object.assign(list, 
          {paymentInformation: {
            cardNumber : data.cardNumber?.replace(/ /g,'-'),// 카드 번호 (ex. "1234-5678-...")
            expiry: data.expiry?expiryFormat(data.expiry):'',// 카드 만료일. YYYY/MM (ex. 2022/11)
            password2Digits: data.password2Digit,// 비밀번호 앞 두자리
            birth: data.birth,// 생년월일 yymmdd (ex. 900703)
          },
          paymentType: 'creditcard'
        }
        )
      }else if(paymentOption === 'KAKAOPAY'){
        list = Object.assign(list, 
          {paymentType: 'kakaopay'},
        )
      }
      }else if(paymentOption === 'NAVERPAY'){
        console.log('NAVERPAY')
        console.log(window.Naver)
        list = Object.assign(list, 
          {paymentType: 'naverpay'},
        )
    }

    if(qs !== {}){
      list = Object.assign(list, qs)
    }

    if(data.stb_recaptcha){
      list.recaptcha = data.stb_recaptcha
    }

    subscribe({listId:listId,registerBody:list})
  }

  //kakaoPay
  function callEasyPayments(data:callEasyPaymentsBodyTypes, redirectUrl?:string) {
    const { paymentType, customerUid, merchantUid, buyerEmail, buyerName, buyerTel } = data
    /* 1. 가맹점 식별하기 */
    // const { IMP } = window;
    IMP.init('imp27287957');

    switch(paymentType){
      case 'KAKAOPAY':
        const data = {
          pg:'kakaopay',
          merchant_uid : merchantUid,
          name : listsInfo.data.listName + ' 최초인증결제',
          amount : 0, // 빌링키 발급만 진행하며 결제승인을 하지 않습니다.
          customer_uid : customerUid, //customer_uid 파라메터가 있어야 빌링키 발급이 정상적으로 이뤄집니다.
          buyer_email : buyerEmail,
          buyer_name : buyerName,
          buyer_tel : buyerTel,
          m_redirect_url :`${redirectUrl}/lists/${listId}/payment/kakao`
        }
        
        /* 4. 결제 창 호출하기 */
        IMP.request_pay(data, 
          function(rsp) {
            if ( rsp.success ) {
              const data = {
                imp_success: rsp.imp_success,
                imp_uid : rsp.imp_uid,
                merchant_uid : rsp.merchant_uid
                //기타 필요한 데이터가 있으면 추가 전달
              }
              const qsSuccess = querystring.stringify(data)
            //테스트 용. 추후 history.push 방식으로 변경
            // alert('빌링키 발급 성공');
            window.location.href = `${redirectUrl}/lists/${listId}/payment/kakao?`+qsSuccess;
          } else if( !rsp.success ){
            const data = {
              imp_success: rsp.imp_success,
              imp_uid : rsp.imp_uid,
              merchant_uid : rsp.merchant_uid,
              error_msg: rsp.error_msg
              //기타 필요한 데이터가 있으면 추가 전달
            }
            const qsFailed = querystring.stringify(data)
            window.location.href = `${redirectUrl}/lists/${listId}/payment/kakao?`+qsFailed;
            // alert('빌링키 발급 실패 '+ qsFailed);
          }
        }
        );
      break;
      case 'NAVERPAY':
        IMP.request_pay({
          pg : 'naverpay',
          customer_uid : 'gildong_0001_1234', //customer_uid 를 활용해 실제 반복결제(승인요청)를 진행하게 됩니다.
          merchant_uid : 'merchant_' + new Date().getTime(), //상점에서 관리하시는 고유 주문번호를 전달
          name : 'Slim 요금제(1개월 단위)',
          amount : 14000, //실제 결제되지는 않으며, 향후 해당 금액으로 반복결제될 예정이라는 의미로 결제창에 표시될 금액만 전달합니다.
          buyer_email : 'iamport@siot.do',
          buyer_name : '구매자이름',
          buyer_tel : '010-1234-5678', //누락되면 이니시스 결제창에서 오류
          buyer_addr : '서울특별시 강남구 삼성동',
          buyer_postcode : '123-456',
          naverProductCode : '반복결제 상품코드', //한 명의 고객이 동일 상품을 중복 결제할 수 없도록 하려면 naverProductCode를 지정해주세요. (누락되면 랜덤값으로 자동 생성)
          naverPopupMode : false, //리디렉션모드 vs 팝업모드
          m_redirect_url : 'https://qa-page.stibee.com/api/v1.0/lists/3/payment/naver'
      }, function(rsp) {
          if ( rsp.success ) {
            //[1] 서버단에서 결제정보 조회를 위해 jQuery ajax로 imp_uid 전달하기
            // jQuery.ajax({
            //   url: "/payments/complete", //cross-domain error가 발생하지 않도록 주의해주세요
            //   type: 'POST',
            //   dataType: 'json',
            //   data: {
            //     imp_uid : rsp.imp_uid
            //     //기타 필요한 데이터가 있으면 추가 전달
            //   }
            // }).done(function(data) {
            //   //[2] 서버에서 REST API로 정상적으로 결제고객 등록이 이뤄졌는지 체크(status : paid 이면 등록 성공을 의미)
            //   if ( everythings_fine ) {
            //     var msg = '결제가 완료되었습니다.';
            //     msg += '\n고유ID : ' + rsp.imp_uid;
            //     msg += '\n상점 거래ID : ' + rsp.merchant_uid;
            //     msg += '\n결제 금액 : ' + rsp.paid_amount;
            //     msg += '카드 승인번호 : ' + rsp.apply_num;
      
            //     alert(msg);
            //   } else {
            //     //[3] 아직 제대로 결제가 되지 않았습니다.
            //     //[4] 결제된 금액이 요청한 금액과 달라 결제를 자동취소처리하였습니다.
            //   }
            // });
          } else {
              // var msg = '결제에 실패하였습니다.';
              // msg += '에러내용 : ' + rsp.error_msg;
      
              // alert(msg);
          }
      });
        break;
    }
  }
  

  //modals
  const [ isFormPolicyModalOpen, setIsFormPolicyModalOpen] = useState(false)
  const [ isAdAgreementModalOpen, setIsAdAgreementModalOpen ] = useState(false)
  const handleClickPolicy = () => setIsFormPolicyModalOpen(!isFormPolicyModalOpen)
  const handleClickAdAgreement = () => setIsAdAgreementModalOpen(!isAdAgreementModalOpen)

  //select paid, nonpaid
  const [ selectPaidSubscription, setSelectPaidSubscription ] = useState<string>(
    formSettings.formPaidFreeSubscriptionShow?'N':'Y'
    // 'N'
    )
  const handleRadioChange = (e:React.ChangeEvent<HTMLInputElement>) => setSelectPaidSubscription(e.target.value)

  //select payments method
  const [ paymentOption, setPaymentOption ] = useState<string>('CREDITCARD')
  const handlePaymentsRadioChange = (e:React.ChangeEvent<HTMLInputElement>) => setPaymentOption(e.target.value)
  
  //recaptcha
  let captcha:any;
  const setCaptchaRef = (ref) => {
    if (ref) {
      return captcha = ref;
    }
  };

  function handleReCAPTCHAonChange(value) {
    clearErrors('stb_recaptcha')
    setCaptchaValue(value)
  }

  

  //vars input창 분기
  const subscriptionStatus = (v:Var) => {
    if(v.substitution === 'email'){
      return (
        <>
          <input 
            type="email" 
            className="stb_form_set_input" 
            name={v.substitution} 
            ref={register({required:true, pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/})} 
          ></input>
          {errors.email?.type === 'required' && <div className="stb_form_msg_error">이메일 주소를 입력하세요.</div>}
          {errors.email?.type === 'pattern' && <div className="stb_form_msg_error">잘못된 이메일 주소입니다.</div>}
          {errors.email?.type === 'duplicated' && 
            <div className="stb_form_msg_error">이미 구독 중인 이메일 주소입니다. 
              <a href={`/subscribers/auth/${listId}?email=${email}`} rel="noopener noreferrer" target="_blank">
                구독 정보 변경하기
              </a>
            </div>
          }
          </>

      )
    }else if(v.substitution !== 'email' && v.isMandatory){
      return(
        <>
          <input 
            type="text"
            className="stb_form_set_input"
            name={v.substitution}
            ref={register({required:true})}
          ></input>
          {errors.hasOwnProperty(v.substitution) && <div className="stb_form_msg_error">{josa(`${v.label}#{을}`)} 입력하세요.</div>}
          {/* {v.substitution === 'name' && errors.name?.type === 'required' && <div className="stb_form_msg_error">{josa(`${v.label}#{을}`)} 입력하세요.</div>}
          {v.substitution === 'phone_number' && errors.phone_number?.type === 'required' && <div className="stb_form_msg_error">{josa(`${v.label}#{을}`)} 입력하세요.</div>} */}
        </>
        )
    }else{
      return(
        <>
          <input type="text" className="stb_form_set_input" name={v.substitution} ref={register}></input>
        </>
      )
    }

  }

  return (
    <>
    {/* <Preloader resolve={()=> getSubscriptionsInfoData(listId)}></Preloader>  */}
    {!formSettings? 
    // <Preloader resolve={()=> getSubsData(listId)}></Preloader> 
    ''
    :
    <>
    <div className={`form-frame ${isIosInstagram?'disableScroll':''}`}>
      <Helmet>
        <title>{formSettings.formTitle ? formSettings.formTitle : listsInfo.data.listName + ' 구독하기'}</title>
        <meta property="og:title" content={formSettings.formTitle ? formSettings.formTitle : listsInfo.data.listName + ' 구독하기'} />
        <meta property="og:image" content={formSettings.formHeaderImage}/>
      </Helmet>
      <div className="inner">
        <div id="stb_subscribe">
          {formSettings.formHeaderImageShow &&
            <div className="stb_header">
              <img src={formSettings.formHeaderImage} alt="formheaderimage"/>
            </div>
          }
          {formSettings.formTitleShow &&
            <h1 className="stb_form_title">{formSettings.formTitle ? formSettings.formTitle : listsInfo.data.listName + ' 구독하기'}</h1>
          }
          {formSettings.formDescriptionShow &&
            <div className="stb_form_description">
              <div dangerouslySetInnerHTML={{ __html: linkify(formSettings.formDescription)}} ></div>
            </div>
          }

        <form onSubmit={handleSubmit(onSubmit)} method="POST" target="_blank" acceptCharset="utf-8" className="stb_form" name="stb_subscribe_form" noValidate>
          {formSettings.formIsActive === 'Y' &&
            varsSettings?.filter(v=>v.show && v.substitution.charAt(0) !== '$' 
              ).map((v,idx)=>
              <fieldset className="stb_form_set" key={idx}>
                <label htmlFor={`stb_${v.substitution}`} className="stb_form_set_label">{v.customLabel?v.customLabel:v.label}</label>
                {subscriptionStatus(v)}
              </fieldset>
            )
          }
          {(formSettings.formIsActive === 'Y' && formSettings.formPaidSubscription === 'Y')&&
          <>
          <fieldset className="stb_form_paid">
            <label className="stb_form_set_label">{formSettings.formPaidFreeSubscriptionShow?'구독 유형':''}</label>
            <div className="stb_subscription_state">
              <label className={`container paid ${selectPaidSubscription==='Y'?'selected':''} ${formSettings.formPaidFreeSubscriptionShow?'':'paid_only'}`}>
                <input 
                  type='radio'
                  checked={selectPaidSubscription==='Y'}
                  onChange={handleRadioChange}
                  value='Y'
                />
                <span className='radiomark'/>
                유료 구독 

                <div className='subscription_price'>월 {numberWithCommas(listsInfo.data.paidSubscriptionItems[1]?.price)}원</div>
              </label>
              {formSettings.formPaidFreeSubscriptionShow &&
                <label className={`container free ${selectPaidSubscription==='N'?'selected':''}`}>
                  <input 
                    type='radio'
                    checked={selectPaidSubscription==='N'}
                    onChange={handleRadioChange}
                    value='N'
                    />
                    <span className='radiomark'/>
                  무료 구독
                </label>
              }
            </div>
          </fieldset>
          </>
          }
          {
          (formSettings.formIsActive === 'Y' && formSettings.formPaidSubscription === 'Y' && selectPaidSubscription === 'Y')&&
          <>
          <fieldset className="stb_form_paid">
          <label className="stb_form_set_label">결제 수단</label>
            <div className="payment_options">
              <label className={`container ${paymentOption==='CREDITCARD'?'selected':''}`}>
                <input 
                  type='radio'
                  checked={paymentOption==='CREDITCARD'}
                  onChange={handlePaymentsRadioChange}
                  value='CREDITCARD'
                  />
                  {/* <span className='radiomark'/> */}
                카드 결제
              </label>
              {/* <label className={`container ${paymentOption==='NAVERPAY'?'selected':''}`}>
                <input 
                  type='radio'
                  checked={paymentOption==='NAVERPAY'}
                  onChange={handlePaymentsRadioChange}
                  value='NAVERPAY'
                />
                <span className='icon_naver_pay'/>
              </label> */}
              <label className={`container ${paymentOption==='KAKAOPAY'?'selected':''}`}>
                <input 
                  type='radio'
                  checked={paymentOption==='KAKAOPAY'}
                  onChange={handlePaymentsRadioChange}
                  value='KAKAOPAY'
                />
                <span className='icon_kakao_pay'/>
                {/* K PAY */}
              </label>
            </div>
          </fieldset>
          </>
          }
          {(formSettings.formIsActive === 'Y' 
          && formSettings.formPaidSubscription === 'Y' 
          && selectPaidSubscription === 'Y' 
          && paymentOption === 'CREDITCARD'
          ) &&
          <div className="stb_form_payment_info">
            <div className='container payment'>
              <CreditCardPaymentFields register={register} errors={errors} setValue={setValue} clearError={clearErrors}/>
              <div className="desc">
                <a href="https://stibee.com" rel="noopener noreferrer" target="_blank">스티비</a>가 결제를 대행합니다.&nbsp;
                <a href="https://www.notion.so/stibee/cf6feb7107784a20b3bae4d0646790e0" rel="noopener noreferrer" target="_blank">이용약관</a>&nbsp;
                <a href="https://www.notion.so/stibee/8ccec3806eba4107a474174399eebd90" rel="noopener noreferrer" target="_blank">개인정보처리방침</a>
              </div>
            </div>
          </div>
          }
          {(smsAgreeShow(varsSettings) && formSettings.formIsActive === 'Y') && 
            <div className="stb_form_sms_policy is_sms_agreed_field">
              <label className="container">
                <input type="checkbox" name="$is_sms_agreed" value="Y" ref={register({required:true})}/>
                <span className="checkmark"></span>
                문자 메시지 수신에 동의합니다.
              </label>
              {errors.$is_sms_agreed && <div className="stb_form_msg_error">문자 메시지 수신에 동의해 주세요.</div>}
              {/* <div className="stb_form_msg_error"></div> */}
            </div>
          }
          {(formSettings.formPolicyShow && formSettings.formIsActive === 'Y') &&
            <div className="stb_form_policy">
              <label className="container">
                <input type="checkbox" value="stb_policy_true" name='stb_policy' ref={register({required:true})}/>
                <span className="checkmark"></span>
                <button type="button" onClick={handleClickPolicy}>개인정보 수집 및 이용</button>에 동의합니다.
              </label>
              {errors.stb_policy && <div className="stb_form_msg_error">개인정보 수집 및 이용에 동의해주세요.</div>}
              {/* <div className="stb_form_msg_error"></div> */}
              <div className={`stb_form_modal stb_form_policy_text ${isFormPolicyModalOpen?'':'blind'}`}>
                <div className="stb_form_modal_body">
                  <h1 className="stb_form_modal_title">개인정보 수집 및 이용</h1>
                  <p className="stb_form_modal_text">
                    {formSettings.formPolicy}
                  </p>
                  <div className="stb_form_modal_btn">
                    <button type="button" onClick={handleClickPolicy}>닫기</button>
                  </div>
                </div>
                <div className="stb_form_modal_bg"></div>
              </div>
            </div>
          }
          {(formSettings.formAdAgreementShow && formSettings.formIsActive === 'Y') &&
            <div className="stb_form_policy">
              <label className="container">
                <input type="checkbox" value="stb_ad_agreement_true" name='stb_ad_agreement' ref={register({required:true})}/>
                <span className="checkmark"></span>
                <button data-modal="stb_form_ad_agreemnet_modal" className="stb_form_modal_open_btn"  type="button" onClick={handleClickAdAgreement}>광고성 정보 수신</button>에 동의합니다.
              </label>
              {errors.stb_ad_agreement && <div className="stb_form_msg_error">광고성 정보 수신에 동의해주세요.</div>}
              {/* <div className="stb_form_msg_error"></div> */}
              <div className={`stb_form_modal stb_form_policy_text ${isAdAgreementModalOpen?'':'blind'}`}>
                <div className="stb_form_modal_body">
                  <h1 className="stb_form_modal_title">광고성 정보 수신</h1>
                  <p className="stb_form_modal_text">
                    {formSettings.formAdAgreement}
                  </p>
                  <div className="stb_form_modal_btn">
                    <button
                      className="stb_form_modal_close_btn"
                      data-modal="stb_form_ad_agreemnet_modal"
                      type="button"
                      onClick={handleClickAdAgreement}
                    >
                      닫기
                    </button>
                  </div>
                </div>
                <div className="stb_form_modal_bg"></div>
              </div>
            </div>
          }
          {(formSettings.formReCaptchaShow && formSettings.formIsActive === 'Y') &&
            <fieldset className="stb_form_recaptcha">
              <input type="hidden" name='stb_recaptcha' value={captchaValue} ref={register({required:true})}/>
              <ReCAPTCHA
                ref={(r) => setCaptchaRef(r) }
                sitekey="6LfyRsoZAAAAAPSOz_cUdMYbdqtLfte1B15CxNpK"
                onChange={handleReCAPTCHAonChange}
              />
              {errors.stb_recaptcha && <div className="stb_form_msg_error">자동입력 방지를 확인해주세요.</div>}
            </fieldset>
          }

          <div className={`stb_form_result ${result}`}>
            <p>{resultMsg}
            {result==='success' && (subscribeStatus.data.code==='Succeed.List.NonConfirm.Paid' || subscribeStatus.data.code==='Succeed.List.NonConfirm.NonPaid')?
              <a href={`/subscribers/auth/${listId}?email=${email}`} rel="noopener noreferrer" target="_blank">구독 정보 변경하기</a>
              :
              ''
            }
            </p>
            <span className='close' onClick={()=>setResult('')}/>
          </div>

          {(formSettings.fieldbutton && formSettings.formIsActive === 'Y') &&
            <fieldset className="stb_form_set_submit ">
              <button type="submit"
                className={`stb_form_submit_button ${subscribeStatus.loading?'disabled':''}`}
                style={{backgroundColor:formSettings.buttonColor, color: formSettings.buttonTextColor}}
                onClick={onClickSubmit}
              >
                {formSettings.formButton}
              </button>
            </fieldset> 
          }
        </form>
        </div>
      </div>
    </div>
    <div className={`guide-instagram ${isIosInstagram ? 'show':''}`}>
      
      <span className="instgram-arrow"/>
      <div className="text">
        카카오페이로 결제하려면<br/>
        <span className="instgram-others"/>을 눌러서<br/>
        “Safari에서 열기” 선택 후,<br/>
        뉴스레터를 구독하세요!<br/><br/><br/><br/>
        <span className="cancel" onClick={()=>setIsIosInstagram(false)}>
          아뇨, 다른 방법으로 결제할게요!
        </span>
      </div>
      
      <div className="bg"></div>
    </div>
    </>
    }
    </>
  )
}

export default SubscriptionsPage

